import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    height: '125vh',
    overflow: 'visible',
    [theme.breakpoints.down('md')]: {
      height: '85vh'
    },
    [theme.breakpoints.down('md')]: {
      height: '100vh'
    }
  }
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <iframe
        title="common footer"
        scrolling="no"
        src="https://stage.sponsorcontent.cnn.com/interactive/common/footer"
        style={{ width: '100%', height: '100%', border: 'none' }}
      ></iframe>
    </div>
  );
};

export default Footer;
